module.exports = __webpack_public_path__ + "img/ZG81_15.7191e2e3.jpg";